<p-fileUpload #fubauto *ngIf="api.adminOrder" accept=".xlsx,.xls" name="file[]" chooseLabel="Importer un bon de commande" (onSelect)="importBdc($event);fubauto.clear()" [auto]="true" mode="basic">
</p-fileUpload>

<p-dialog [(visible)]="displayForImport" *ngIf="prodNotImported" [modal]="true" minWidth="500" [modal]="true" >
	<p-header>
		Les produits suivants n'ont pas pu être importé car la référence ne correspond pas.
	</p-header>
	<ul>
		<li *ngFor="let item of prodNotImported">
			{{item['Référence']}} - {{item['Désignation']}}
		</li>
	</ul>
	Vous pouvez les ajouter manuellement.
</p-dialog>